/**
 * Formateadores es-PE (fechas y moneda) usados en toda la consola (docs/FASE-1.md §6). Puros, sin
 * dependencias del DOM ni de React: se prueban con `node --import tsx --test`.
 */

const LOCALE = "es-PE";

const dateFormatter = new Intl.DateTimeFormat(LOCALE, { dateStyle: "medium" });
const dateTimeFormatter = new Intl.DateTimeFormat(LOCALE, { dateStyle: "medium", timeStyle: "short" });
const numberFormatter = new Intl.NumberFormat(LOCALE);

function toValidDate(iso: string): Date | null {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** Formatea una fecha ISO 8601 a fecha corta es-PE. `null`/`undefined`/inválida → "—". */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const date = toValidDate(iso);
  return date ? dateFormatter.format(date) : "—";
}

/** Formatea una fecha ISO 8601 a fecha y hora es-PE. `null`/`undefined`/inválida → "—". */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const date = toValidDate(iso);
  return date ? dateTimeFormatter.format(date) : "—";
}

/**
 * Formatea un monto monetario. Los DTOs de planes lo traen como string decimal
 * (`PlanSchema.priceMonthly`), por eso acepta ambos tipos. Valor no numérico → "—".
 */
export function formatCurrency(amount: string | number, currency = "PEN"): string {
  const value = typeof amount === "string" ? Number(amount) : amount;
  if (!Number.isFinite(value)) return "—";
  return new Intl.NumberFormat(LOCALE, { style: "currency", currency }).format(value);
}

/** Formatea un número con separador de miles es-PE. `null`/`undefined` → "Ilimitado" (semántica de límites). */
export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined) return "Ilimitado";
  return numberFormatter.format(value);
}

/** Vista previa corta de un secreto (para mostrarlo truncado si hiciera falta); nunca el valor completo. */
export function formatSecretPreview(secret: string): string {
  if (secret.length <= 8) return secret;
  return `${secret.slice(0, 4)}…${secret.slice(-4)}`;
}
